// Copyright © 2026 Gian Marco Cappelli — SAPIENS (finsapiens.it). Tutti i diritti riservati. Sviluppato su commissione esclusiva. Vietata la riproduzione senza autorizzazione scritta.
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Bar } from 'react-chartjs-2';
import { EducBox, ChartBox, ResultCard, InputRow, PremiumLock, EDUC, baseChartOpts, barLabelPlugin, fmt } from './shared';

const CostoFondiCalc = () => {
  const [investito, setInvestito] = useState('10000');
  const [mensile, setMensile] = useState('200');
  const [anni, setAnni] = useState('20');
  const [rendimento, setRendimento] = useState('7');
  const [ter1, setTer1] = useState('1.5');
  const [ter2, setTer2] = useState('0.2');

  const P = parseFloat(investito) || 0;
  const m = parseFloat(mensile) || 0;
  const n = parseInt(anni) || 0;
  const r = parseFloat(rendimento) / 100;
  const t1 = parseFloat(ter1) / 100;
  const t2 = parseFloat(ter2) / 100;

  const calc = (ter) => {
    const netR = r - ter;
    const rM = netR / 12;
    return rM !== 0 ? P * Math.pow(1 + rM, n * 12) + m * (Math.pow(1 + rM, n * 12) - 1) / rM : P + m * n * 12;
  };

  const v1 = calc(t1);
  const v2 = calc(t2);
  const diff = v2 - v1;

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} style={{ position: 'relative' }}>
      <EducBox text={EDUC.fondi} />
      <div className="grid sm:grid-cols-2 gap-4 mb-6">
        <InputRow label="Capitale iniziale (€)" value={investito} onChange={setInvestito} prefix="€" />
        <InputRow label="Versamento mensile (€)" value={mensile} onChange={setMensile} prefix="€" />
        <InputRow label="Orizzonte (anni)" value={anni} onChange={setAnni} suffix="anni" />
        <InputRow label="Rendimento lordo (%)" value={rendimento} onChange={setRendimento} suffix="%" />
        <InputRow label="TER Fondo attivo (%)" value={ter1} onChange={setTer1} suffix="%" />
        <InputRow label="TER ETF passivo (%)" value={ter2} onChange={setTer2} suffix="%" />
      </div>
      <div className="grid grid-cols-3 gap-4">
        <ResultCard label={`Fondo attivo (TER ${ter1}%)`} value={`€${fmt(v1)}`} />
        <ResultCard label={`ETF passivo (TER ${ter2}%)`} value={`€${fmt(v2)}`} green />
        <ResultCard label="Risparmio con ETF" value={`€${fmt(diff)}`} gold />
      </div>
      <ChartBox height={320}>
        <Bar
          data={{
            labels: ['Fondo attivo', 'ETF passivo'],
            datasets: [{ data: [Math.round(v1), Math.round(v2)], backgroundColor: ['rgba(201,168,76,0.7)', 'rgba(61,122,82,0.7)'], borderRadius: 8, borderSkipped: false }],
          }}
          options={baseChartOpts()}
          plugins={[barLabelPlugin]}
        />
      </ChartBox>
      <div style={{ position: 'absolute', inset: 0 }}><PremiumLock /></div>
</motion.div>
  );
};

export default CostoFondiCalc;
